import { createPinia } from 'pinia';

export const piniaConfig = createPinia();
